import React, { useState } from "react";

import { IStringField } from "../models/formFields";
import { FormInputFieldWrapper } from "./FormInputFieldWrapper";
import { useFormField } from "./hooks/useFormField";

export const FormPasswordInput = <T extends string>(
    props: IStringField<T>,
): React.ReactNode => {
    const { type = "password", minLength, maxLength } = props;

    const [isRevealed, setIsRevealed] = useState(false);
    const field = useFormField<T, HTMLInputElement>({
        ...props,
        type: type,
    });

    const onTogglePasswordVisibility = (
        e: React.MouseEvent<HTMLElement>,
    ): void => {
        e.preventDefault();
        setIsRevealed((prev) => !prev);
    };

    const inputProps = {
        ...field.inputProps,
        minLength,
        maxLength,
        type: isRevealed ? "text" : "password",
        autoComplete: "new-password",
        className: props.className ?? "form__field__input",
    };

    return (
        <FormInputFieldWrapper
            {...props}
            type={type}
            focused={field.focused}
            isRequired={field.isRequired}
            onLabelClick={field.onLabelClick}
        >
            <div className="form__field__password-input-group">
                <input ref={field.inputRef} {...inputProps} />
                <button
                    className="form__field__password-reveal-toggle"
                    onClick={onTogglePasswordVisibility}
                    aria-label={isRevealed ? "Hide password" : "Show password"}
                >
                    {isRevealed ? "Hide" : "Show"}
                </button>
            </div>
        </FormInputFieldWrapper>
    );
};
